export default class LanguageEvent {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

LanguageEvent.INITIALIZE = "LanguageEvent.INITIALIZE";
LanguageEvent.PROMPT = "LanguageEvent.PROMPT";
LanguageEvent.SELECT = "LanguageEvent.SELECT";
LanguageEvent.SELECTED = "LanguageEvent.SELECTED";